import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MarketplaceEmailSender } from '@spike/email-marketing-model';
import { useMarketplace } from 'hooks';
import moment from 'moment';
import { FunctionComponent } from 'react';
import EmailSenderSectionHeader from '../EmailSenderSectionHeader';
import RecipientsWillSeeCard from '../RecipientsWillSeeCard';
import { useEmailSenderData } from '../hooks/useEmailSenderData';
import { SHOW_CUDDLES_DEFAULT_ESCAPE } from './senderFeatureFlags';
import sharedStyles from './states.module.scss';

interface VerifiedStateProps {
    sender: MarketplaceEmailSender;
    /** Opens the edit modal pre-filled with the current address. */
    onEdit: () => void;
    /** Opens the "Use Cuddles default?" confirm modal. */
    onEscape: () => void;
}

/**
 * Verified — campaigns now go out from `sender.senderEmail`. The
 * RecipientsWillSeeCard renders the From-header preview alongside the Edit
 * Email button so the user can swap addresses without scanning a separate
 * action bar (mockup 4).
 */
const VerifiedState: FunctionComponent<VerifiedStateProps> = ({ sender, onEdit, onEscape }) => {
    const { saving } = useEmailSenderData();
    const marketplace = useMarketplace();
    const businessName = marketplace?.basics?.businessName ?? '';

    const verifiedAtFormatted = sender.verifiedAt ? moment(sender.verifiedAt).format('LL [at] h:mm A') : null;

    return (
        <div className={sharedStyles.container}>
            <EmailSenderSectionHeader />

            <div className={sharedStyles.content}>
                <div className={sharedStyles.emailRow}>
                    <p className={sharedStyles.email}>{sender.senderEmail}</p>
                    <span className={`${sharedStyles.badge} ${sharedStyles.badgeVerified}`}>
                        <FontAwesomeIcon icon={faCheck} />
                        Verified
                    </span>
                </div>

                {verifiedAtFormatted && <p className={sharedStyles.metaLine}>Verified on {verifiedAtFormatted}</p>}

                <RecipientsWillSeeCard
                    senderEmail={sender.senderEmail ?? ''}
                    businessName={businessName}
                    onEditEmail={onEdit}
                />
            </div>

            {SHOW_CUDDLES_DEFAULT_ESCAPE && (
                <p className={sharedStyles.escapeLine}>
                    Don&apos;t want a custom sender?{' '}
                    <button
                        type="button"
                        className={sharedStyles.escapeLink}
                        onClick={onEscape}
                        disabled={saving}
                    >
                        Use the Cuddles default instead
                    </button>
                </p>
            )}
        </div>
    );
};

export default VerifiedState;
